import { SVGProps } from "react";

export default function PrescriptionIcon({
  width = "24",
  height = "24",
  className = "",
  stroke = "#000080",
}: SVGProps<SVGSVGElement> & { stroke?: string }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_prescription_icon)">
        <path
          d="M21.6 6H15.6V2.4C15.6 1.08 14.52 0 13.2 0H10.8C9.48 0 8.4 1.08 8.4 2.4V6H2.4C1.08 6 0 6.9 0 8.4V21.6C0 22.92 1.08 24 2.4 24H21.6C22.92 24 24 22.92 24 21.6V8.4C24 6.9 22.92 6 21.6 6ZM10.8 2.4H13.2V8.4H10.8V2.4ZM21.6 21.6H2.4V8.4H8.4C8.4 9.72 9.48 10.8 10.8 10.8H13.2C14.52 10.8 15.6 9.72 15.6 8.4H21.6V21.6ZM10.8 16.8H8.4V19.2H6V16.8H3.6V14.4H6V12H8.4V14.4H10.8V16.8ZM13.2 15V12H20.4V15H13.2ZM13.2 18.6V16.2H18V18.6H13.2Z"
          fill={stroke}
        />
      </g>
      <defs>
        <clipPath id="clip0_prescription_icon">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
